import { View } from 'react-native'
import styled from 'styled-components/native'

export const AvatarContainer = styled(View)`
  margin: auto;
  margin-bottom: 40px;
`

export const Separator = styled(View)`
  border: 1px solid #d1d3d4;
  margin: 20px 0;
`
